import script from "./FinalPaySale.vue?vue&type=script&lang=ts&setup=true&name=FinalPaySale"
export * from "./FinalPaySale.vue?vue&type=script&lang=ts&setup=true&name=FinalPaySale"

import "./FinalPaySale.vue?vue&type=style&index=0&id=eb634820&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/admin-tmp/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb634820"]])

export default __exports__